import { render } from "./contentBase.vue?vue&type=template&id=53cdfbae&scoped=true"
import script from "./contentBase.vue?vue&type=script&lang=js"
export * from "./contentBase.vue?vue&type=script&lang=js"

import "./contentBase.vue?vue&type=style&index=0&id=53cdfbae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cdfbae"]])

export default __exports__